import './Sos.css'
import { useState } from 'react'
import { Modal, Tab, Tabs } from 'react-bootstrap'
import { Siren, Settings } from 'lucide-react'
import SosTab from './SosTab'
import ConfigurationTab from './ConfigurationTab'
import { useDispatch, useSelector } from 'react-redux'
import { toggleSosModal } from '../../../../redux/slices/globalSlice'
import { useTranslation } from 'react-i18next'

export default function SosModal() {

    const [activeTab, setActiveTab] = useState('sos')
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const show = useSelector((state) => state.global.sosModal)

    const handleClose = () => {
        setActiveTab('sos')
        dispatch(toggleSosModal())
    }

    return (
        <Modal
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            size="lg"
            centered
            className="sos-modal"
        >
            <Modal.Header closeButton>
                <Modal.Title as="h5"><Siren size={20} />{t('sos.sos_module')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Tabs
                    activeKey={activeTab}
                    onSelect={(key) => setActiveTab(key)}
                    className="modern_tabs mb-3"
                    variant="pills"
                    fill
                >
                    <Tab
                        eventKey="sos"
                        title={
                            <span className="d-flex align-items-center justify-content-center gap-2">
                                <Siren size={14} />
                                {t('sos.tab_sos')}
                            </span>
                        }
                    >
                        <SosTab />
                    </Tab>
                    <Tab
                        eventKey="configuration"
                        title={
                            <span className="d-flex align-items-center justify-content-center gap-2">
                                <Settings size={14} />
                                {t('sos.tab_configuration')}
                            </span>
                        }
                    >
                        <ConfigurationTab />
                    </Tab>
                </Tabs>
            </Modal.Body>
        </Modal>
    )
}